import { render, staticRenderFns } from "./BaseCardRestaurantAdvanced.vue?vue&type=template&id=0452b2d8&scoped=true&"
import script from "./BaseCardRestaurantAdvanced.vue?vue&type=script&lang=ts&"
export * from "./BaseCardRestaurantAdvanced.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCardRestaurantAdvanced.vue?vue&type=style&index=0&id=0452b2d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452b2d8",
  null
  
)

export default component.exports